import HTTP from '@/config/axios-default-config'

const ServiceEcomplaints = {
  
  // Recupera la info de la tabla de denuncias
  getComplaints(payload) {
    return HTTP.post('ecanaldenuncias/getComplaints', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Guarda la info de una nueva denuncia
  setComplaint(payload) {
    return HTTP.post('ecanaldenuncias/setComplaint', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Modifica el estado de la denuncia
  setComplaintStatus(payload) {
    return HTTP.post('ecanaldenuncias/setComplaintStatus', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera la info general de una denuncia
  getComplaintData(payload) {
    return HTTP.post('ecanaldenuncias/getComplaintData', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera la lista de tipos de denuncias
  getComplaintTypes(payload) {
    return HTTP.post('ecanaldenuncias/getComplaintTypes', payload).then(response => {
      return this.genericResponse(response)
    })
  },
  
  // Elimina un tipo de denuncia
  delComplaintType(payload) {
    return HTTP.post('ecanaldenuncias/delComplaintType', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Actualiza un tipo de denuncia
  updateComplaintType(payload) {
    return HTTP.post('ecanaldenuncias/updateComplaintType', payload).then(response => {
      return this.genericResponse(response)
    })
  },
  
  // Guarda la info de un nuevo tipo de denuncia
  setComplaintType(payload) {
    return HTTP.post('ecanaldenuncias/setComplaintType', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera la info del usuarios (nombre, mail y telefono) para un usuario
  getUserData(payload) {
    return HTTP.post('ecanaldenuncias/getUserData', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera los comentarios asociados a una denuncia
  getComplaintComments(payload) {
    return HTTP.post('ecanaldenuncias/getComplaintComments', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Establece el orden de las tareas 
  updateTasksOrder(payload) {
    return HTTP.post('ecanaldenuncias/updateTasksOrder', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Guarda el comentario de una denuncia
  setComplaintComment(payload) {
    return HTTP.post('ecanaldenuncias/setComplaintComment', payload).then(response => {
      return this.genericResponse(response)
    })
  }, 

  // Inserta un log de acceso a la denuncia
  setComplaintAccess(payload) {
    return HTTP.post('ecanaldenuncias/setComplaintAccess', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera la lista de accesos a una denuncia 
  getComplaintAccess(payload) {
    return HTTP.post('ecanaldenuncias/getComplaintAccess', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera la lista de eventos/historial de una denuncia
  getComplaintLogs(payload) {
    return HTTP.post('ecanaldenuncias/getComplaintLogs', payload).then(response => {
      return this.genericResponse(response)
    })
  }, 

  // Recupera la lista de tareas asociadas a una denuncia
  getComplaintTasks(payload) {
    return HTTP.post('ecanaldenuncias/getComplaintTasks', payload).then(response => {
      return this.genericResponse(response)
    })
  }, 

  // Recupera si el usuario es gestor o no
  getManagerPermission(payload) {
    return HTTP.post('ecanaldenuncias/getManagerPermission', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Lista gestores del canal (HRM_P_DEN) con usuario, nombre completo y email
  getManagersDen(payload) {
    return HTTP.post('ecanaldenuncias/getManagersDen', payload).then(response => {
      return this.genericResponse(response)
    })
  }, 
  
  // Recupera la info de una denuncia anónima
  getAnonymComplaint(payload) {
    return HTTP.post('ecanaldenuncias/getAnonymComplaint', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Recupera los ficheros asociados a una denuncia
  getComplaintFiles(payload) {
    return HTTP.post('ecanaldenuncias/getComplaintFiles', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Guarda una tarea del plan de acción
  setTaskPDA(payload) {
    return HTTP.post('ecanaldenuncias/setTaskPDA', payload).then(response => {
      return this.genericResponse(response)
    })
  },  
  
  // Borra una tarea del plan de acción
  delTaskPDA(payload) {
    return HTTP.post('ecanaldenuncias/delTaskPDA', payload).then(response => {
      return this.genericResponse(response)
    })
  },

  // Actualiza los datos de una tarea del plan de acción
  updateTaskPDA(payload) {
    return HTTP.post('ecanaldenuncias/updateTaskPDA', payload).then(response => {
      return this.genericResponse(response)
    })
  },  

  // Recupera la url de descarga de un fichero
  getFileUrl(payload) {
    return HTTP.post('ecanaldenuncias/getFileUrl', payload).then(response => {
      return this.genericResponse(response)
    })
  },  

  // Recupera la lista de usuarios con denuncias
  getUsersList(payload) {
    return HTTP.post('ecanaldenuncias/getUsersList', payload).then(response => {
      return this.genericResponse(response)
    })
  },  

  // Recupera los ficheros asociados a una tarea del plan de acción
  getTaskFiles(payload) {
    return HTTP.post('ecanaldenuncias/gestTaskFiles', payload).then(response => {
      return this.genericResponse(response)
    })
  },  

  // Añade ficheros a una denuncia ya introducida
  updateComplaintFiles(payload) {
    return HTTP.post('ecanaldenuncias/updateComplaintFiles', payload).then(response => {
      return this.genericResponse(response)
    })
  },  

  // Añade ficheros a un plan de acción ya introducido
  updateTaskFiles(payload) {
    return HTTP.post('ecanaldenuncias/updateTaskFiles', payload).then(response => {
      return this.genericResponse(response)
    })
  },  
  
  // Recupera la plantilla html para los ficheros de denuncia anónima o acuse de recibo 
  getComplaintPdf(payload) {
    return HTTP.post('ecanaldenuncias/getComplaintPdf', payload).then(response => {
      return this.genericResponse(response)
    })
  }, 

  // Respuesta genérica para todos los servicios
  genericResponse (response) {
    if (response.status === 200 && response.data.result !== 'ko') {
      return response.data
    } else {
      console.error(response.status, response.data)
      throw response.data
    }
  }
}
export default ServiceEcomplaints
